var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{attrs:{"type":_vm.type},on:{"click":_vm.copyToClipboard}},[_c('span',{staticClass:"icon is-small"},[_c('i',{staticClass:"fas",class:_vm.icon})])])
}
var staticRenderFns = []

export { render, staticRenderFns }